import type { Interpolation } from '@common/ui-components';

export const tableContentCss: Interpolation<Record<string, unknown>> = {
  tableLayout: 'fixed',
};
